import { render } from "./sitemap.svg?vue&type=template&id=3ebc6a75"
const script = {}
script.render = render

export default script